var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("PDF TEST")]),_c('q-uploader',{staticStyle:{"max-width":"300px"},attrs:{"url":"/api/pdfupload","color":"green","flat":"","bordered":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }